(function () {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    const menuRoot = document.querySelector(".mobile_main_nav_list");
    const menuBtn = document.querySelector(".menu-btn");
    const menuDrawer = document.querySelector(".mobile_navigation_wrap");
    const html = document.documentElement;
    if (!menuRoot) return;

    // function setActive(li) {
    //   const parentUl = li.closest("ul");
    //   if (!parentUl) return;

    //   const siblings = parentUl.querySelectorAll(":scope > li");
    //   siblings.forEach((sib) => {
    //     if (sib === li) {
    //       sib.classList.add("item_active");
    //       sib.classList.remove("item_disable");
    //     } else {
    //       sib.classList.remove("item_active");
    //       sib.classList.add("item_disable");
    //     }
    //   });
    // }

    // function clearStates() {
    //   menuRoot
    //     .querySelectorAll("li")
    //     .forEach((li) =>
    //       li.classList.remove("item_active", "item_disable")
    //     );
    // }

    function isCheckboxChecked(li) {
      const checkbox = li.querySelector(":scope > .m-menu__checkbox");
      return checkbox && checkbox.checked;
    }

    // ---------------- HOVER ----------------
    // menuRoot.addEventListener("mouseover", function (e) {
    //   const li = e.target.closest("li");
    //   if (!li || !menuRoot.contains(li)) return;

    //   const from = e.relatedTarget;
    //   if (from && li.contains(from)) return;

    //   if (isCheckboxChecked(li)) {
    //     li.classList.remove("item_active", "item_disable");
    //     return;
    //   }

    //   setActive(li);
    // });

    // ---------------- REMOVE ACTIVE WHEN MOUSE LEAVES LI ----------------
    menuRoot.addEventListener("mouseout", function (e) {
      const li = e.target.closest("li");
      if (!li || !menuRoot.contains(li)) return;

      const to = e.relatedTarget;
      if (to && li.contains(to)) return;

      li.classList.remove("item_active", "item_disable");

      const parentUl = li.closest("ul");
      if (parentUl) {
        parentUl.querySelectorAll(":scope > li").forEach((sib) =>
          sib.classList.remove("item_active", "item_disable")
        );
      }
    });

    // ---------------- CLICK ----------------
    // menuRoot.addEventListener("click", function (e) {
    //   const li = e.target.closest("li");
    //   if (!li || !menuRoot.contains(li)) return;
    //   e.stopPropagation();

    //   if (isCheckboxChecked(li)) {
    //     li.classList.remove("item_active", "item_disable");
    //     return;
    //   }

    //   const parentUl = li.closest("ul");
    //   const siblings = parentUl.querySelectorAll(":scope > li");

    //   if (li.classList.contains("item_active")) {
    //     siblings.forEach((sib) =>
    //       sib.classList.remove("item_active", "item_disable")
    //     );
    //   } else {
    //     setActive(li);
    //   }
    // });

    // ---------------- OUTSIDE CLICK CLEAR STATES ----------------
    // document.addEventListener("click", function (e) {
    //   if (
    //     html.classList.contains("menu_drawer_open") &&
    //     menuDrawer &&
    //     !menuDrawer.contains(e.target) &&
    //     menuBtn &&
    //     !menuBtn.contains(e.target)
    //   ) {
    //     html.classList.remove("menu_drawer_open");
    //     clearStates();
    //   }
    // });

    // ---------------- MENU BUTTON ----------------
    // menuBtn?.addEventListener("click", function (e) {
    //   e.stopPropagation();

    //   if (html.classList.contains("menu_drawer_open")) {
    //     html.classList.remove("menu_drawer_open");
    //   } else {
    //     html.classList.add("menu_drawer_open");
    //   }
    // });
  }
})();


// Menu Icon Custom (converted from jQuery)
document.addEventListener("DOMContentLoaded", function () {
  const menuBtn = document.querySelector(".menu-btn");
  const body = document.body;
  const html = document.documentElement;
  const modalSearch = document.querySelector(".modal-search");
  const overlay = document.querySelector(".mobile_menu_overlay");
  const crossBtn = document.querySelector(".mobile-nav-trigger_cross");

  // When menu button is clicked
  if (menuBtn) {
    menuBtn.addEventListener("click", function () {

      const isOpen = html.classList.contains("menu_drawer_open");

      if (isOpen) {
        // Close
        html.classList.remove("menu_drawer_open");
        body.classList.remove("mobile_nav_opened", "mobile_nav_bar_top_no_scroll");
        menuBtn.classList.remove("open", "isactive");
      } else {
        // Open
        html.classList.add("menu_drawer_open");
        body.classList.add("mobile_nav_opened");
        menuBtn.classList.add("open", "isactive");

        if (window.scrollY === 0) {
          body.classList.add("mobile_nav_bar_top_no_scroll");
        }
      }

      if (modalSearch) {
        modalSearch.classList.remove("expand-searchnew", "show");
        modalSearch.style.display = "none";
      }
    });
  }

  // When clicking on overlay — close menu
  if (overlay) {
    overlay.addEventListener("click", function () {
      body.classList.remove("mobile_nav_opened", "mobile_nav_bar_top_no_scroll");
      html.classList.remove("overflow_hidden");
      html.classList.remove("menu_drawer_open");

      body.style.overflow = "";
      body.style.height = "";

      menuBtn?.classList.remove("open", "isactive");
    });
  }

  // When cross button is clicked (optional separate close icon)
  if (crossBtn) {
    crossBtn.addEventListener("click", function () {
      body.classList.remove("mobile_nav_opened", "mobile_nav_bar_top_no_scroll");
      html.classList.remove("overflow_hidden");
      html.classList.remove("menu_drawer_open");

      body.style.overflow = "";
      body.style.height = "";

      menuBtn?.classList.remove("open", "isactive");
    });
  }
});


// Announcement Bar
document.addEventListener("DOMContentLoaded", () => {
  const announcementBarContainer = document.querySelector(".mds-animated-banner__slider-container");
  if (!announcementBarContainer) return;
  const announcementSlides = announcementBarContainer.querySelectorAll(".mds-animated-banner__content");
  let activeSlideIndex = 0;
  function updateSlideClasses() {
    announcementSlides.forEach(slide => {
      slide.classList.remove("-visible", "-next");
    });
    announcementSlides[activeSlideIndex].classList.add("-visible");
    const nextSlideIndex = (activeSlideIndex + 1) % announcementSlides.length;
    announcementSlides[nextSlideIndex].classList.add("-next");
  }
  function showNextAnnouncementSlide() {
    activeSlideIndex = (activeSlideIndex + 1) % announcementSlides.length;
    updateSlideClasses();
  }
  updateSlideClasses();
  setInterval(showNextAnnouncementSlide, 4000);

  // Mobile: show after first scroll only
  if (window.matchMedia("(max-width: 991px)").matches) {
    if (window.scrollY > 0) {
      document.body.classList.add("mobile-announcement-visible");
    } else {
      window.addEventListener(
        "scroll",
        function () {
          document.body.classList.add("mobile-announcement-visible");
        },
        {
          once: true,
          passive: true
        }
      );
    }
  } else {
    document.body.classList.add("mobile-announcement-visible");
  }
});


// Scroll handling: direction + sticky header
document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  let lastScroll = 0;
  const scrollThreshold = 64;

  window.addEventListener("scroll", function () {
    const currentScroll = window.pageYOffset;

    // header_sticky toggle
    if (currentScroll > 0) {
      body.classList.add("header_sticky");
    } else {
      body.classList.remove("header_sticky");
    }

    // scroll direction toggle
    if (currentScroll > scrollThreshold) {
      if (currentScroll > lastScroll) {
        body.classList.add("body_scroll_down");
        body.classList.remove("body_scroll_up");
      } else {
        body.classList.add("body_scroll_up");
        body.classList.remove("body_scroll_down");
      }
    } else {
      body.classList.remove("body_scroll_down", "body_scroll_up");
    }

    lastScroll = currentScroll;
  });
});

document.addEventListener('DOMContentLoaded', function () {

    const wrapper = document.querySelector('.mobile-nav-menu-wrapper');
    let lastScroll = 0;

    if (!wrapper) return;

    /* ---------------------------------
       SUBMENU OPEN (Freeze → Reset → Unfreeze)
    ----------------------------------*/
    document.querySelectorAll('.m-menu__checkbox').forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {

            wrapper.style.scrollBehavior = 'auto';

            if (this.checked && window.matchMedia("(max-width: 991.98px)").matches) {
                // Save current scroll
                lastScroll = wrapper.scrollTop;

                // Freeze scrolling
                wrapper.style.overflow = 'hidden';

                // Jump to top instantly
                wrapper.scrollTop = 0;

                // Unfreeze next frame
                requestAnimationFrame(function () {
                    wrapper.style.overflow = '';
                });
            }
        });
    });

    /* ---------------------------------
       SUBMENU CLOSE (Freeze → Restore → Unfreeze)
    ----------------------------------*/
    document.querySelectorAll('.m-menu__toggle').forEach(function (toggle) {
        toggle.addEventListener('click', function () {

            // Freeze before restoring scroll
            wrapper.style.overflow = 'hidden';

            // Restore previous scroll position
            wrapper.scrollTop = lastScroll;

            // Unfreeze next frame
            requestAnimationFrame(function () {
                wrapper.style.overflow = '';
            });
        });
    });
});


window.addEventListener('scroll', function () {
  const headerNav = document.querySelector('.header_Nav');

  if (!headerNav) return;

  if (window.scrollY > 0) {
    headerNav.classList.add('fixed-nav-container');
  } else {
    headerNav.classList.remove('fixed-nav-container');
  }
});



window.addEventListener('load', () => {
  requestAnimationFrame(() => {
    document.documentElement.classList.remove('preload');
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // ---------- helpers ----------
  function $$(selector, ctx) {
    return Array.prototype.slice.call(
      (ctx || document).querySelectorAll(selector),
    );
  }
  function $1(selector, ctx) {
    return (ctx || document).querySelector(selector);
  }
  function siblings(el, selector) {
    var out = [];
    if (!el || !el.parentElement) return out;
    var kids = el.parentElement.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i] !== el && (!selector || kids[i].matches(selector)))
        out.push(kids[i]);
    }
    return out;
  }
  function childrenOf(el, selector) {
    var out = [];
    if (!el) return out;
    var kids = el.children;
    for (var i = 0; i < kids.length; i++) {
      if (!selector || kids[i].matches(selector)) out.push(kids[i]);
    }
    return out;
  }
  function fireChange(el) {
    el.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // Forward declarations for functions used inside handlers before assignment.
  var loadNavGrid, loadNavGridUl, showCharmsGroup, setupCharmsPanel;
  var openNavBranch, hydrateNavThumbs;

  // ---------- third_layer_header ----------
  document.querySelectorAll(".third_layer_header").forEach(function (header) {
    header.addEventListener("click", function () {
      // va the checkbox within the same .m-menu container as the clicked header
      var parentElement = header.parentElement.parentElement;
      var checkbox = parentElement.querySelector(".third_layer_menu_checked");
      if (checkbox) {
        checkbox.checked = false; // Uncheck the checkbox
      }
    });
  });

  // ---------- desktop search modal ----------
  $$("li.desktop-search span").forEach(function (el) {
    el.addEventListener("click", function () {
      var modal = $1(".modal-search-desktop");
      if (modal) modal.classList.add("model-active");
      var input = $1('input[name="q"].search_input');
      if (input) input.focus();
    });
  });
  $$(".modal-search-desktop button.close-search-modal").forEach(function (el) {
    el.addEventListener("click", function () {
      var modal = $1(".modal-search-desktop");
      if (modal) modal.classList.remove("model-active");
    });
  });

  // ---------- mobile menu mask / hamburger ----------
  $$(".mobile_menu_mask").forEach(function (mask) {
    mask.addEventListener("click", function () {
      var body = document.body;
      // Check if the user has scrolled vertically
      if (window.scrollY > 0) {
        // Add the 'scrolled' class to the body
        body.classList.add("header_sticky");
      } else {
        // Remove the 'scrolled' class if the user scrolls back to the top
        body.classList.remove("header_sticky");
      }
      body.style.overflow = "";
      body.style.height = "";
      body.querySelectorAll(".js-hamburgernav").forEach(function (el) {
        el.classList.remove("isactive");
      });
      body.querySelectorAll(".navmm").forEach(function (el) {
        el.classList.remove("is-activenav");
      });
    });
  });

  $$(".js-hamburgernav").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var body = document.body;
      body.style.height = "100vh";
      body.querySelectorAll(".js-hamburgernav").forEach(function (el) {
        el.classList.add("isactive");
      });
      body.querySelectorAll(".navmm").forEach(function (el) {
        el.classList.add("is-activenav");
      });
    });
  });

  $$(".mobile-nav-trigger_cross").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var body = document.body;
      // Check if the user has scrolled vertically
      if (window.scrollY > 0) {
        // Add the 'scrolled' class to the body
        body.classList.add("header_sticky");
      } else {
        // Remove the 'scrolled' class if the user scrolls back to the top
        body.classList.remove("header_sticky");
      }

      body.style.height = "";

      body.style.overflow = "";
      body.style.height = "";
      body.querySelectorAll(".js-hamburgernav").forEach(function (el) {
        el.classList.remove("isactive");
      });
      body.querySelectorAll(".navmm").forEach(function (el) {
        el.classList.remove("is-activenav");
      });
    });
  });

  // The scroll-to-top + second_menu_opened choreography belongs to the
  // mobile slide-over pattern only. On desktop (>=992px) panels open
  // BESIDE the list, which keeps its own scroll position.
  var isMobileNav = function () {
    return window.matchMedia("(max-width: 991.98px)").matches;
  };

  var scrollNavmmToTop = function () {
    // var navmm = $1(".mobile-nav-menu .m-menu.navmm");
    // if (!navmm) return;
    // navmm.scrollTop = navmm.getBoundingClientRect().top + window.scrollY;
  };

  $$(".m-menu__checkbox").forEach(function (cb) {
    cb.addEventListener("change", function () {
      if (this.checked) {
        if (this.classList.contains("traveltoggle")) {
          $$(".main-toggle-travel").forEach(function (el) {
            el.classList.add("move-left");
          });

          // Delay before adding the second menu class
          setTimeout(function () {
            if (isMobileNav()) {
                $$(".mobile-nav-menu .is-activenav").forEach(function (el) {
                    el.classList.add("second_menu_opened");
                });
            }
            $$(".custonM-animation").forEach(function (el) {
              el.classList.add("custom-travel-opener");
            });
          }, 300); // Adjust the delay time (in milliseconds) as needed
        } else if (isMobileNav()) {
          // scrollNavmmToTop();

          $$(".mobile-nav-menu .is-activenav").forEach(function (el) {
            el.classList.add("second_menu_opened");
          });
        }
      } else {
        if (this.classList.contains("traveltoggle")) {
          $$(".airplane-image").forEach(function (el) {
            el.classList.remove("travel-animation");
          });
        }
        if (isMobileNav()) {
            $$(".mobile-nav-menu .is-activenav").forEach(function (el) {
                el.classList.add("second_menu_opened");
            });
          }
        }
    });
  });

  $$(".m-menu__header").forEach(function (header) {
    header.addEventListener("click", function () {
      $$(".main-toggle-travel").forEach(function (el) {
        el.classList.remove("move-left");
      });
      $$(".custonM-animation").forEach(function (el) {
        el.classList.remove("custom-travel-opener");
      });
      $$(".mobile-nav-menu .is-activenav").forEach(function (el) {
        el.classList.remove("second_menu_opened");
      });
    });
  });

  // Side-flyout state keeping (all viewports): the checkbox hack lets
  // several branches stay open at once, but the columns share the same
  // slot next to the drawer — so opening a branch closes its siblings,
  // and closing a branch closes anything nested inside it. Every open
  // also starts scrolled to the top: the scroller keeps its position
  // otherwise, and a reopened panel would sit wherever it was left
  // (blank-looking until the card entrances replay).
  $$(".mobile_main_nav_list").forEach(function (root) {
    root.addEventListener("change", function (e) {
      var cb = e.target.closest(".m-menu__checkbox");
      if (!cb || !root.contains(cb)) return;
      if (cb.checked) {
        var panel = cb.nextElementSibling;
        if (panel && panel.classList.contains("m-menu")) {
          loadNavGrid(panel);
          // hard reset — no smooth-scroll animation. The panel
          // itself is the scroller on mobile peeks; its uls are
          // the scrollers everywhere else.
          // panel.style.scrollBehavior = "auto";
          // panel.scrollTop = 0;
          // panel.style.scrollBehavior = "";
          // panel.querySelectorAll("ul").forEach(function (ul) {
          //   ul.style.scrollBehavior = "auto";
          //   ul.scrollTop = 0;
          //   ul.style.scrollBehavior = "";
          // });
        }
        var li = cb.closest("li");
        if (li) {
          siblings(li, "li").forEach(function (sib) {
            sib.querySelectorAll(".m-menu__checkbox").forEach(function (c) {
              if (c.checked) c.checked = false;
            });
          });
        }
      } else {
        siblings(cb, ".m-menu").forEach(function (sib) {
          sib.querySelectorAll(".m-menu__checkbox").forEach(function (c) {
            if (c.checked) c.checked = false;
          });
        });
      }
    });
  });

  // Reset panels once the drawer has finished closing (menu button,
  // overlay or cross) so the next open always starts at level 1.
  // Bound DIRECTLY on the elements — custom_script.js stops the
  // menu button's click from propagating, so a document-delegated
  // handler would never fire for the only working trigger.
  var mdsResetNavPanels = function () {
    $$(".mobile_main_nav_list .m-menu__checkbox").forEach(function (c) {
      if (c.checked) c.checked = false;
    });
    $$(".mobile-nav-menu .m-menu.navmm").forEach(function (el) {
      el.classList.remove("second_menu_opened");
    });
    // Setting .checked directly fires no change event, so clear the
    // travel toggle's companion classes here too.
    $$(".main-toggle-travel").forEach(function (el) {
      el.classList.remove("move-left");
    });
    $$(".custonM-animation").forEach(function (el) {
      el.classList.remove("custom-travel-opener");
    });
    $$(".airplane-image").forEach(function (el) {
      el.classList.remove("travel-animation");
    });
  };
  $$(".menu-btn, .mobile_menu_overlay, .mobile-nav-trigger_cross").forEach(
    function (el) {
      el.addEventListener("click", function () {
        setTimeout(function () {
          if (!document.body.classList.contains("mobile_nav_opened")) {
            mdsResetNavPanels();
          }
        }, 1200);
        // The delayed reset above loses a race: reopening within its
        // 1.2s window makes the closed-guard see the drawer open again
        // and skip — so the last flyout was still showing. Belt and
        // braces on the OPEN side: once this click's handlers settle,
        // if the drawer is open with a stale panel still checked,
        // clear it instantly — transitions suppressed inline so the
        // drawer opens at level 1 with no visible collapse.
        setTimeout(function () {
          if (!document.body.classList.contains("mobile_nav_opened")) return;
          var checked = $$(".mobile_main_nav_list .m-menu__checkbox").filter(
            function (c) {
              return c.checked;
            },
          );
          if (!checked.length) return;
          var panels = $$(".mobile_main_nav_list .m-menu");
          panels.forEach(function (p) {
            p.style.transition = "none";
          });
          mdsResetNavPanels();
          if (panels[0]) void panels[0].offsetWidth; // commit the collapsed state before re-arming
          panels.forEach(function (p) {
            p.style.transition = "";
          });
        }, 0);
      });
    },
  );

  // Flyout row thumbnails ship as data-src and hydrate on first menu
  // open — see nav-link-thumb.liquid for why plain loading=lazy
  // can't defer them. Re-runs are cheap and idempotent. (The big
  // product grids are no longer in the served page at all — see
  // loadNavGrid.)
  hydrateNavThumbs = function () {
    $$(".mobile_navigation_wrap .nav-flyout-thumb img[data-src]").forEach(
      function (img) {
        if (img.getAttribute("data-srcset")) {
          img.setAttribute("sizes", img.getAttribute("data-sizes") || "64px");
          img.setAttribute("srcset", img.getAttribute("data-srcset"));
          img.removeAttribute("data-srcset");
          img.removeAttribute("data-sizes");
        }
        img.src = img.getAttribute("data-src");
        img.removeAttribute("data-src");
      },
    );
  };
  $$(".menu-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      hydrateNavThumbs();
    });
  });

  // The page scroll-lock classes MUST die with the drawer no
  // matter HOW it closes (X, overlay tap, leaf navigation).
  // Legacy code only toggles html.menu_drawer_open from the
  // menu button itself, so overlay-closes left the page frozen
  // (base.css: html.menu_drawer_open { overflow: hidden }).
  new MutationObserver(function () {
    if (!document.body.classList.contains("mobile_nav_opened")) {
      document.documentElement.classList.remove(
        "menu_drawer_open",
        "overflow_hidden",
      );
    }
  }).observe(document.body, { attributes: true, attributeFilter: ["class"] });

  $$(".mobile_main_nav_list").forEach(function (root) {
    root.addEventListener("change", function (e) {
      var cb = e.target.closest(".m-menu__checkbox");
      if (cb && root.contains(cb)) hydrateNavThumbs();
    });
  });

  // Heavy product grids (peeks + Bags) are not server-rendered into
  // every page — each fetches once, on its panel's first open, via
  // the Section Rendering API (sections/nav-peek-grid.liquid and
  // nav-bags-grid.liquid). The fetch rides under the panel's 0.7s
  // slide-out; .nav-grid-enter re-arms the staggered card entrance
  // for content inserted into an already-open panel.
  // Charms split panel: the fetched grid arrives FLAT — every
  // product li tagged with its group (data-charms-group) and
  // hidden. The LEFT grid is built from those tags (one card per
  // group, fronted by the group's first product image); clicking a
  // group card reveals its products in the separated right column
  // as a 2-up grid, headlined by the group name, with the standard
  // card cascade. One fetch — switching never refetches.
  showCharmsGroup = function (split, key, auto) {
    var grid = split.querySelector(".charms-products-grid");
    if (!grid) return;
    split.classList.add("has-selection"); // opens the column: grid pushes across (desktop) / section appears (mobile)
    split
      .querySelectorAll(".charms-groups-grid button[data-charms-group]")
      .forEach(function (b) {
        b.classList.toggle(
          "is-active",
          b.getAttribute("data-charms-group") === key,
        );
      });
    var i = 0;
    var groupLabel = "";
    grid.classList.add("nav-grid-enter");
    grid.querySelectorAll("li[data-charms-group]").forEach(function (li) {
      var show = li.getAttribute("data-charms-group") === key;
      li.hidden = !show;
      if (show) {
        li.style.setProperty("--card-i", i++);
        if (!groupLabel)
          groupLabel = li.getAttribute("data-charms-group-label") || key;
        // The whole group loads NOW (small thumbs) instead of
        // lazy-hitching row by row while the column scrolls.
        li.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.loading = "eager";
          img.decoding = "async";
        });
      }
    });
    var subTitle = split.querySelector(".charms-sub-title");
    if (subTitle) subTitle.textContent = groupLabel; // mobile sub-panel header
    grid.scrollTop = 0;
    void grid.offsetWidth; // commit the hidden pose before re-arming the cascade
    requestAnimationFrame(function () {
      grid.classList.remove("nav-grid-enter");
    });
    // Mobile: the products are a sub-panel — slide it in over the
    // groups like a third-level takeover (its back label returns).
    // The overlay lays out at the scroll canvas's TOP
    // (fixed-in-transform acts like absolute), so it's anchored
    // to the parent's CURRENT scroll offset instead: the grid
    // keeps its position — no jump — and only backing out resets.
    if (!auto && window.matchMedia("(max-width: 991.98px)").matches) {
      var panel = split.closest(".m-menu");
      var subPanel = split.querySelector(".charms-sub-panel");
      if (panel && subPanel)
        subPanel.style.setProperty(
          "--charms-sub-top",
          panel.scrollTop + "px",
        );
      var sub = split.querySelector(".charms-sub-checkbox");
      if (sub && !sub.checked) {
        sub.checked = true;
        fireChange(sub); // rides the hydration machinery
      }
    }
  };
  setupCharmsPanel = function (grid) {
    var split = grid.closest(".charms-panel-split");
    var groups = split && split.querySelector(".charms-groups-grid");
    if (!groups || groups.childElementCount) return;
    var order = [];
    var byKey = {};
    grid.querySelectorAll("li[data-charms-group]").forEach(function (li) {
      var key = li.getAttribute("data-charms-group");
      if (!byKey[key]) {
        byKey[key] = { li: li, count: 0 };
        order.push(key);
      }
      byKey[key].count++;
    });
    order.forEach(function (key, idx) {
      var g = byKey[key];
      var item = document.createElement("li");
      item.style.setProperty("--card-i", idx);
      var el;
      if (g.count === 1) {
        // Single-product group: the card links STRAIGHT to
        // that product — opening a one-card column would just
        // add a click.
        el = document.createElement("a");
        var productLink = g.li.querySelector("a");
        if (productLink) el.href = productLink.href;
      } else {
        el = document.createElement("button");
        el.type = "button";
        el.setAttribute("data-charms-group", key);
      }
      var thumb = g.li.querySelector(".nav-flyout-thumb");
      if (thumb) {
        var thumbClone = thumb.cloneNode(true);
        var thumbImg = thumbClone.querySelector("img");
        if (thumbImg) {
          // Eager + async: lazy imgs decode mid-scroll and
          // each row entering the viewport hitches the flick.
          thumbImg.loading = "eager";
          thumbImg.decoding = "async";
        }
        el.appendChild(thumbClone);
      }
      // var text = document.createElement("span");
      // text.className = "nested_menu_text";
      // text.textContent = g.li.getAttribute("data-charms-group-label") || key;
      // el.appendChild(text);
      var caption = document.createElement("span");
      caption.className = "nav-card-caption";
      var text = document.createElement("span");
      text.className = "nested_menu_text";
      text.textContent = g.li.getAttribute("data-charms-group-label") || key;
      var badge = document.createElement("span");
      badge.className = "nav-grid-badge-placeholder";
      caption.appendChild(text);
      caption.appendChild(badge);
      el.appendChild(caption);
      item.appendChild(el);
      groups.appendChild(item);
      const badgeData = JSON.parse(grid.dataset.navBadges || "{}");
      groups.querySelectorAll("li").forEach(function(card){
          const title =
              card.querySelector(".nested_menu_text")
                  .textContent.trim();
          const data = badgeData[title];
          if(!data) return;
          const placeholder =
              card.querySelector(".nav-grid-badge-placeholder");
          if(!placeholder) return;
          placeholder.innerHTML = `
              <span
                  class="headr-bdg spanmobile"
                  style="
                      color:${data.color};
                      background:${data.bg};
                  ">
                  ${data.badge}
              </span>
          `;
      });
    });
    // No auto-select: the flyout opens as the pure full-width
    // group grid — the column only exists once a group is picked.
  };
  $$(".mobile_main_nav_list").forEach(function (root) {
    root.addEventListener("click", function (e) {
      var btn = e.target.closest(
        ".charms-groups-grid button[data-charms-group]",
      );
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation(); // the panel's label/checkbox machinery must not react
      var split = btn.closest(".charms-panel-split");
      if (split) showCharmsGroup(split, btn.getAttribute("data-charms-group"));
    });
  });
  // Backing out of the products sub-panel returns to a FRESH group
  // grid: hard scroll reset (the panel is still scrolled to where
  // the group was tapped) and the entrance cascade replayed —
  // its built-in delay lets the sub-panel mostly clear first.
  $$(".mobile_main_nav_list").forEach(function (root) {
    root.addEventListener("change", function (e) {
      var cb = e.target.closest(".charms-sub-checkbox");
      if (!cb || !root.contains(cb)) return;
      if (cb.checked || !window.matchMedia("(max-width: 991.98px)").matches)
        return;
      var panel = cb.closest(".m-menu"); // the charms MAIN panel (the sub is a sibling, not an ancestor)
      var split = cb.closest(".charms-panel-split");
      var groups = split && split.querySelector(".charms-groups-grid");
      // if (panel) {
      //   var prevBehavior = panel.style.scrollBehavior;
      //   panel.style.scrollBehavior = "auto"; // the global smooth-scroll must not animate the reset
      //   panel.scrollTop = 0;
      //   panel.style.scrollBehavior = prevBehavior;
      // }
      // Clear the overlay's scroll anchor in the SAME frame as the
      // reset — top and scrollTop drop by the same amount, so the
      // outgoing slide stays glued to the screen (net zero).
      var subPanel = split && split.querySelector(".charms-sub-panel");
      if (subPanel) subPanel.style.removeProperty("--charms-sub-top");
      // Nothing is "selected" once back on the grid — drop the
      // tapped card's underline along with the reset.
      if (split) {
        split
          .querySelectorAll(".charms-groups-grid button.is-active")
          .forEach(function (b) {
            b.classList.remove("is-active");
          });
      }
      if (groups) {
        groups.classList.add("nav-grid-enter");
        void groups.offsetWidth;
        requestAnimationFrame(function () {
          groups.classList.remove("nav-grid-enter");
        });
      }
    });
  });
  // Every (re)open starts fresh: full-width group grid, no column,
  // nothing marked active. Runs on open (not close) so there's no
  // race with the close animation.
  $$(".mobile_main_nav_list").forEach(function (root) {
    root.addEventListener("change", function (e) {
      var cb = e.target.closest(".m-menu__checkbox");
      if (!cb || !root.contains(cb)) return;
      if (!cb.checked) return;
      var panel = cb.nextElementSibling;
      var split =
        panel && panel.querySelector
          ? panel.querySelector(".charms-panel-split")
          : null;
      if (!split || !split.classList.contains("has-selection")) return;
      // Instant, not animated — this rides the panel's slide-out
      // and must not show the column visibly collapsing.
      var gridUl = split.querySelector(".charms-products-grid");
      if (gridUl) gridUl.style.transition = "none";
      split.classList.remove("has-selection");
      var subCheckbox = split.querySelector(".charms-sub-checkbox");
      if (subCheckbox) subCheckbox.checked = false; // mobile sub-panel parks closed
      split
        .querySelectorAll(".charms-groups-grid button.is-active")
        .forEach(function (b) {
          b.classList.remove("is-active");
        });
      if (gridUl) {
        void gridUl.offsetWidth; // commit the collapsed state before restoring the ease
        gridUl.style.transition = "";
      }
    });
  });

  loadNavGridUl = function (ul) {
    if (
      !ul ||
      ul.classList.contains("is-loaded") ||
      ul.classList.contains("is-loading")
    )
      return;
    ul.classList.add("is-loading");
    var root =
      (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    fetch(
      root +
        "collections/" +
        ul.getAttribute("data-nav-grid") +
        "?section_id=" +
        ul.getAttribute("data-nav-grid-section"),
    )
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var grid = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector("ul");
        if (!grid) throw new Error("no grid");
        ul.classList.add("nav-grid-enter");
        ul.innerHTML = grid.innerHTML;
        // add badge to collection products dynamically from customization 
        const badgeData = JSON.parse(ul.dataset.navBadges || "{}");
          ul.querySelectorAll("li").forEach(function(card){
              const titleEl = card.querySelector(".nested_menu_text");
              if(!titleEl) return;
              const title = titleEl.textContent.trim();
              if(!badgeData[title]) return;
              const data = badgeData[title];
              const placeholder = card.querySelector(".nav-grid-badge-placeholder");
              if(!placeholder) return;
              placeholder.innerHTML = `
                  <span
                      class="headr-bdg spanmobile"
                      style="
                          color:${data.color};
                          background:${data.bg};
                      ">
                      ${data.badge}
                  </span>
              `;
          }); 

        // Filter excluded bag product types
          const excludedTypes = (ul.dataset.excludedTypes || "")
            .split(/[\n,]+/)
            .map(type => type.trim().toLowerCase())
            .filter(Boolean);
          ul.querySelectorAll("li[data-product-type]").forEach(function (card) {
            const productType = (card.dataset.productType || "")
              .trim()
              .toLowerCase();
            const shouldExclude = excludedTypes.some(function(type) {
              return productType.includes(type);
            });
            if (shouldExclude) {
              card.remove();
            }
          });
        // const badge = ul.dataset.badge;
        // const badgeColor = ul.dataset.badgeColor;
        // const badgeBg = ul.dataset.badgeBg;
        // if (badge) {
        //     ul.querySelectorAll(".nav-grid-badge-placeholder").forEach(function (el) {
        //         el.outerHTML = `
        //             <span
        //                 class="headr-bdg spanmobile"
        //                 style="color:${badgeColor};background:${badgeBg};">
        //                 ${badge}
        //             </span>
        //         `;
        //     });
        // }

        ul.classList.remove("is-loading");
        ul.classList.add("is-loaded");
        if (ul.classList.contains("charms-products-grid"))
          setupCharmsPanel(ul);
        void ul.offsetWidth; // commit hidden state before re-arming the entrance
        requestAnimationFrame(function () {
          ul.classList.remove("nav-grid-enter");
        });
      })
      .catch(function () {
        ul.classList.remove("is-loading"); // retry on next open
      });
  };
  loadNavGrid = function (panel) {
    loadNavGridUl(panel.querySelector("ul[data-nav-grid]"));
  };
  // Prefetch every flyout grid the moment the drawer opens — the
  // fetches ride under the drawer's slide-in, so panels feel as
  // instant as when the grids were inline (only menu-openers pay).
  $$(".menu-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      document
        .querySelectorAll(".mobile_navigation_wrap ul[data-nav-grid]")
        .forEach(loadNavGridUl);
    });
  });

  // Mobile: a collection leaf with a peek opens it as a slide-over
  // instead of navigating (the panel's View all link reaches the
  // collection page). Desktop keeps click-to-navigate.
  $$(".mobile_main_nav_list").forEach(function (root) {
    root.addEventListener("click", function (e) {
      var link = e.target.closest("li.custom_sales_nav > a");
      if (!link || !root.contains(link)) return;
      var mobileWidth = window.matchMedia("(max-width: 991.98px)").matches;
      // Tablets: desktop WIDTH but no hover — a tap must open the
      // flyout like hover would (straight navigation loses the
      // whole panel). A second tap on the open item navigates.
      if (!mobileWidth && !window.matchMedia("(hover: none)").matches) return;
      var checkbox = siblings(link, ".m-menu__checkbox")[0];
      if (!checkbox) return;
      if (!mobileWidth && checkbox.checked) return; // second tap: navigate
      e.preventDefault();
      if (mobileWidth) {
        checkbox.checked = true;
        fireChange(checkbox);
      } else {
        // Tablet: full desktop choreography (retract-then-open /
        // same-width swap), not a bare checkbox flip.
        openNavBranch(link.closest("li"));
      }
    });
  });
  // Touch-at-desktop-width exclusivity: hover-intent normally
  // retracts the open flyout when another opens, but it never runs
  // without a hover-capable pointer — enforce one-panel-out here.
  $$(".mobile_main_nav_list").forEach(function (root) {
    root.addEventListener("change", function (e) {
      var cb = e.target.closest(".m-menu__checkbox");
      if (!cb || !root.contains(cb)) return;
      if (!cb.checked) return;
      if (window.matchMedia("(max-width: 991.98px)").matches) return;
      if (!window.matchMedia("(hover: none)").matches) return;
      if (
        cb.classList.contains("charms-sub-checkbox") ||
        cb.classList.contains("third_layer_menu_checked")
      )
        return;
      var self = cb;
      $$(".mobile_main_nav_list > li > .m-menu__checkbox").forEach(
        function (c) {
          if (c !== self && c.checked) {
            c.checked = false;
            fireChange(c);
          }
        },
      );
    });
  });

  // Desktop hover-intent: a flyout only stays out while the pointer
  // is on its own branch (tab or panel). Pausing on a flyout tab
  // opens/switches to its column; pausing on a leaf item (no flyout)
  // animates the open column back. Switching is strictly sequential:
  // the open column fully retracts FIRST, then the hovered branch
  // slides out — the two columns never animate over each other. The
  // 250ms dwell keeps the pointer from triggering panels while it
  // merely crosses items on its way into an open column.
  var hoverSwitchTimer = null;
  var pendingOpenTimer = null;
  // ONE entry point for opening/switching a branch. Mouse hover
  // (after its 250ms dwell) and tablet taps both route through it,
  // so touch gets the identical choreography: sequential
  // retract-then-open on width changes, in-place same-width swap,
  // third-level rows included (the delegated handlers match nested
  // lis/labels too).
  openNavBranch = function (li) {
    var checkbox = childrenOf(li, ".m-menu__checkbox")[0];
    var openCheckboxes = [];
    siblings(li, "li").forEach(function (sib) {
      sib.querySelectorAll(".m-menu__checkbox").forEach(function (c) {
        if (c.checked) openCheckboxes.push(c);
      });
    });
    clearTimeout(pendingOpenTimer);
    if (!checkbox) {
      // Leaf item: any open sibling flyout animates back.
      openCheckboxes.forEach(function (c) {
        c.checked = false;
      });
    } else if (openCheckboxes.length) {
      var panelOut = openCheckboxes[0].nextElementSibling;
      var panelIn = checkbox.nextElementSibling;
      var sameWidth =
        panelOut &&
        panelIn &&
        panelOut.classList.contains("m-menu") &&
        panelIn.classList.contains("m-menu") &&
        panelOut.offsetWidth === panelIn.offsetWidth;
      if (sameWidth) {
        // Same-width switch: the panel surface holds still.
        // Phase 1 — the outgoing items drop + fade (reverse
        // of their entrance). Phase 2 — the surfaces swap
        // with slides suppressed (.m-menu--swap) and the
        // incoming grid cascades in.
        panelOut.classList.add("m-menu--cards-exit");
        pendingOpenTimer = setTimeout(function () {
          panelOut.classList.add("m-menu--swap");
          panelIn.classList.add("m-menu--swap");
          openCheckboxes.forEach(function (c) {
            c.checked = false;
          });
          checkbox.checked = true;
          fireChange(checkbox);
          panelOut.classList.remove("m-menu--cards-exit");
          setTimeout(function () {
            panelOut.classList.remove("m-menu--swap");
            panelIn.classList.remove("m-menu--swap");
          }, 80);
        }, 260);
      } else {
        // Width change: the whole open flyout translates back
        // under the main menu first, then the new one animates
        // in at its own size.
        panelOut.classList.remove("m-menu--cards-exit");
        openCheckboxes.forEach(function (c) {
          c.checked = false;
        });
        pendingOpenTimer = setTimeout(function () {
          checkbox.checked = true;
          fireChange(checkbox);
        }, 600);
      }
    } else {
      checkbox.checked = true;
      fireChange(checkbox);
    }
  };
  $$(".mobile_main_nav_list").forEach(function (root) {
    // mouseenter delegated via mouseover + relatedTarget check
    root.addEventListener("mouseover", function (e) {
      var li = e.target.closest("li");
      if (!li || !root.contains(li)) return;
      // Only when actually entering the li (not moving between its children).
      if (e.relatedTarget && li.contains(e.relatedTarget)) return;
      if (window.matchMedia("(max-width: 991.98px)").matches) return;
      // Touch devices emit SYNTHETIC hover on tap — the tap
      // handlers own opening there, and this racing them would
      // double-fire the choreography.
      if (window.matchMedia("(hover: none)").matches) return;
      var checkbox = childrenOf(li, ".m-menu__checkbox")[0];
      clearTimeout(hoverSwitchTimer);
      if (checkbox && checkbox.checked) return; // hovering the open branch: stay out
      hoverSwitchTimer = setTimeout(function () {
        openNavBranch(li);
      }, 250);
    });
    root.addEventListener("mouseout", function (e) {
      var li = e.target.closest("li");
      if (!li || !root.contains(li)) return;
      if (e.relatedTarget && li.contains(e.relatedTarget)) return;
      clearTimeout(hoverSwitchTimer);
    });
  });

  // While a drawer list is scrolling, suspend hover-intent too — a
  // wheel scroll sweeps rows under the pointer, and pausing
  // mid-scroll must not open or switch flyouts. (Capture phase:
  // scroll events do not bubble.)
  document.addEventListener(
    "scroll",
    function (e) {
      if (
        e.target instanceof Element &&
        e.target.closest(".mobile_navigation_wrap")
      ) {
        clearTimeout(hoverSwitchTimer);
      }
    },
    true,
  );

  // Promo toast: re-parent to <body> — inside the header section a
  // transform (mobile hide-on-scroll) traps both its z-index and
  // its fixed positioning. The X hides it for this page view only —
  // it returns on refresh/navigation.
  var promoToast = document.querySelector(".mds-promo-toast");
  if (promoToast) document.body.appendChild(promoToast);
  (function () {
      var toast = document.querySelector(".mds-promo-toast");
      if (!toast) return;
      var arm = function () { toast.classList.add("is-armed"); };
      if (window.scrollY > 0) { arm(); return; }
      window.addEventListener("scroll", arm, { once: true, passive: true });
  })();
  $$(".mds-promo-toast__close").forEach(function (btn) {
    btn.addEventListener("click", function () {
      this.closest(".mds-promo-toast").classList.add("is-dismissed");
    });
  });
  // Messages wider than the card scroll to their end before the
  // rotator switches. Re-measured on every rotation (the rotator
  // toggles -visible on the slides; the observer filters to those
  // so re-arming the animation can't feed back into itself).
  if (promoToast) {
    var armPromoScroll = function () {
      // The toast is hidden while the drawer is open — its
      // scrollWidth reads force layout mid-scroll for nothing.
      if (document.body.classList.contains("mobile_nav_opened")) return;
      promoToast
        .querySelectorAll(".promo-bar__content")
        .forEach(function (p) {
          p.classList.remove("is-scrolling");
          p.style.removeProperty("--promo-shift");
          p.style.removeProperty("--promo-dur");
        });
      var visible = promoToast.querySelector(
        ".mds-animated-banner__content.-visible .promo-bar__content",
      );
      if (!visible) return;
      var overflow = visible.scrollWidth - visible.clientWidth;
      if (overflow > 4) {
        visible.style.setProperty("--promo-shift", "-" + overflow + "px");
        visible.style.setProperty(
          "--promo-dur",
          Math.max(1.2, overflow / 45) + "s",
        );
        void visible.offsetWidth; // restart the animation cleanly
        visible.classList.add("is-scrolling");
      }
    };
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (
          t.classList &&
          t.classList.contains("mds-animated-banner__content")
        ) {
          armPromoScroll();
          return;
        }
      }
    }).observe(promoToast, {
      attributes: true,
      subtree: true,
      attributeFilter: ["class"],
    });
    window.addEventListener("load", armPromoScroll);
    armPromoScroll();

    // Yield to ANY floating chrome that overlaps the toast —
    // sticky add-to-carts, newsletter/app popups (and their dim
    // overlays), chat launchers, sliding flyouts — without
    // naming any of them: hit-test the toast's own spot and hide
    // while a visible fixed (or bottom-pinned sticky) element
    // sits there, above or below it. Closed drawers/panels are
    // translated off-screen or visibility:hidden in this theme,
    // so they never register.
    var promoOverlapsChrome = function () {
      var r = promoToast.getBoundingClientRect();
      if (!r.width || !r.height) return false;
      // Probe the RESTING spot (bottom: 20px) — while yielded
      // the card is translated below the viewport, and the
      // question is whether its home position is clear again.
      var y = Math.min(
        window.innerHeight - 20 - r.height / 2,
        window.innerHeight - 1,
      );
      var xs = [r.left + 6, (r.left + r.right) / 2, r.right - 6];
      var prev = promoToast.style.pointerEvents;
      promoToast.style.pointerEvents = "none"; // let the probe see through itself
      var clash = false;
      for (var i = 0; i < xs.length && !clash; i++) {
        var x = Math.min(Math.max(xs[i], 0), window.innerWidth - 1);
        var node = document.elementFromPoint(x, y);
        while (
          node &&
          node !== document.body &&
          node !== document.documentElement
        ) {
          if (node === promoToast || promoToast.contains(node)) break;
          var cs = getComputedStyle(node);
          if (cs.visibility === "hidden" || parseFloat(cs.opacity) < 0.05)
            break;
          // .pdp-fs__panel: desktop-only — there it's the
          // floating glass card (position:absolute, so the
          // fixed test misses it); on mobile it's ordinary
          // flowing content and the buy zone is guarded by
          // the fixed sticky-ATC instead. data-mds-toast-yield
          // lets any future component opt in declaratively.
          var isFsCard =
            node.classList.contains("pdp-fs__panel") &&
            window.matchMedia("(min-width: 990px)").matches;
          if (
            cs.position === "fixed" ||
            isFsCard ||
            node.hasAttribute("data-mds-toast-yield")
          ) {
            clash = true;
            break;
          }
          if (cs.position === "sticky") {
            var sr = node.getBoundingClientRect();
            // bottom-pinned BARS clash: short, hugging the
            // bottom edge, starting in the lower half. Tall
            // sticky layout columns (the PDP info container,
            // which merely STARTS low at scroll 0) don't.
            if (
              sr.height < window.innerHeight * 0.5 &&
              sr.top > window.innerHeight * 0.45 &&
              sr.bottom > window.innerHeight - 8
            )
              clash = true;
            break;
          }
          node = node.parentElement;
        }
      }
      promoToast.style.pointerEvents = prev;
      return clash;
    };
    // The FOOTER is the one bottom occupant the hit-test can't
    // see — it's ordinary in-flow content, not fixed/sticky. The
    // toast slides away (its usual yield exit) the moment any
    // part of the footer section scrolls into view, and rises
    // back once the footer leaves.
    var footerOnScreen = false;
    var footerSectionEl = document.querySelector(".shopify-section-group-footer-group");
    if (footerSectionEl && "IntersectionObserver" in window) {
      new IntersectionObserver(function(entries){
          footerOnScreen = entries[0].isIntersecting;
          queuePromoYield();
      },{
          threshold:0
      }).observe(footerSectionEl);
    }
    var promoYieldTimer;
    var promoYieldTick = function () {
        if (promoToast.classList.contains("is-dismissed")) { clearInterval(promoYieldTimer); return; }
        if (document.hidden) return;
        // Drawer open: the toast is hidden by the class hooks and
        // elementFromPoint forces layout — never probe mid-drawer.
        if (document.body.classList.contains("mobile_nav_opened")) return;
        // footerOnScreen first: while at the footer the (layout-
        // forcing) hit-test probe is skipped entirely.
        promoToast.classList.toggle("is-yielding", footerOnScreen || promoOverlapsChrome());
    };
    var promoYieldQueued = false;
    var queuePromoYield = function () {
      if (promoYieldQueued) return;
      promoYieldQueued = true;
      requestAnimationFrame(function () {
        promoYieldQueued = false;
        promoYieldTick();
      });
    };
    promoYieldTimer = setInterval(promoYieldTick, 600); // catches timed popups (newsletter etc.)
    window.addEventListener("scroll", queuePromoYield, { passive: true }); // catches scroll-revealed sticky ATCs fast
    window.addEventListener("resize", queuePromoYield);
    promoYieldTick();
  }

  // Desktop: hover owns open/close, so a label click must not toggle
  // the checkbox — otherwise hovering a tab opens it and the natural
  // follow-up click immediately closes it again. Keyboard users are
  // unaffected (Space acts on the focusable checkbox directly).
  $$(".mobile_main_nav_list").forEach(function (root) {
    root.addEventListener("click", function (e) {
      var label = e.target.closest("label.a-label__chevron");
      if (!label || !root.contains(label)) return;
      if (window.matchMedia("(max-width: 991.98px)").matches) return;
      // Both pointer types: the checkbox belongs to the hover /
      // tap machinery, never to the native label toggle.
      e.preventDefault();
      if (!window.matchMedia("(hover: none)").matches) return;
      // Tablets: tap opens with the full desktop choreography;
      // tapping the OPEN branch's tab retracts it.
      var li = label.closest("li");
      var checkbox = childrenOf(li, ".m-menu__checkbox")[0];
      if (checkbox && checkbox.checked) {
        checkbox.checked = false;
        fireChange(checkbox);
      } else {
        openNavBranch(li);
      }
    });
  });

  // ---------- search icon / input ----------
  $$(".search-icon-nav-m .btn-search").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var input = $1(".fordesktoponly .search_input");
      if (input) input.focus();
    });
  });
  $$(".fordesktoponly .search_input").forEach(function (input) {
    input.addEventListener("keyup", function () {
      var searchinput_new = this.value;
      var viewall = document.getElementById("viewall");
      if (viewall)
        viewall.setAttribute("href", "/search?q=" + searchinput_new);
      if (searchinput_new.length >= 1) {
        document.body.classList.add("navsearch_tint");
      } else {
        document.body.classList.remove("navsearch_tint");
      }
    });
  });
  document.addEventListener("click", function (a) {
    if (!(a.target instanceof Element) || !a.target.matches("body")) {
      $$(".fordesktoponly .search_input", document.body).forEach(function (
        el,
      ) {
        el.value = "";
      });
      $$(".fordesktoponly .all_product_search", document.body).forEach(
        function (el) {
          el.style.display = "none";
        },
      );
      document.body.classList.remove("navsearch_tint");
    }
  });
  // for search page starts
  // Original guard was $(a.target).is('.search_tint .for_desktopsearchpage:before')
  // — pseudo-elements never match a real event target, so the block always ran.
  document.addEventListener("click", function () {
    $$(".for_desktopsearchpage .search_input", document.body).forEach(
      function (el) {
        el.value = "";
      },
    );
    $$(".for_desktopsearchpage .all_product_search", document.body).forEach(
      function (el) {
        el.style.display = "none";
      },
    );
    document.body.classList.remove("search_tint");
  });
  // ends
  $$(".forcross_mobile").forEach(function (el) {
    el.addEventListener("click", function () {
      document.body.classList.remove("searchfilter_open");
    });
  });
  $$(".search-icon-nav-m .btn-search").forEach(function (btn) {
    btn.addEventListener("click", function () {
      document.body.classList.add("searchfilter_open");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var prevNowPlaying = null;
  document.querySelectorAll(".btn-search").forEach(function (btn) {
    btn.addEventListener("click", function (a) {
      document.querySelectorAll(".fordesktoponly").forEach(function (el) {
        if (el.parentElement) el.parentElement.classList.add("expand-search");
      });
      a.stopPropagation();
      prevNowPlaying = setInterval(function () {
        var input = document.querySelector(".fordesktoponly .search_input");
        if (input) input.focus();
      }, 500);
    });
  });

  document.addEventListener("click", function (a) {
    if (
      !(a.target instanceof Element) ||
      !a.target.matches(".search_input.expand-search")
    ) {
      document.querySelectorAll(".modal-search").forEach(function (el) {
        el.classList.remove("expand-search");
        el.style.display = "none";
      });
      clearInterval(prevNowPlaying);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".search_input").forEach(function (input) {
    input.addEventListener("click", function () {
      this.classList.add("expand-search");
    });
  });
});



document.addEventListener("DOMContentLoaded", function () {

    const menuBtn = document.querySelector(".menu-btn");

    if (!menuBtn) return;

    function updateBurger() {

        const open =
            document.body.classList.contains("mobile_nav_opened") ||
            document.documentElement.classList.contains("menu_drawer_open");

        menuBtn.classList.toggle("open", open);
        menuBtn.classList.toggle("isactive", open);
    }

    new MutationObserver(updateBurger).observe(document.body, {
        attributes: true,
        attributeFilter: ["class"]
    });

    new MutationObserver(updateBurger).observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["class"]
    });

    updateBurger();

});